import moment from "moment/moment";
import { Col, Container, Row } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import userService from "../../service/UserService";
import { kycStatusMap } from "../../common/constant";
import { ToastContainer, toast } from "react-toastify";

export function ViewUser() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [user, setUser] = useState();
  const [referrer, setReferrer] = useState()
  const [kycLink, setKycLink] = useState(); 

  useEffect(() => {
    fetchUser()
  }, [id])

  const fetchUser = async () => {
    const response = await userService.getOne(id);
    if (response.status == 200) {
      setUser(response.data.data)

      const referredBy = response.data.data.referredBy
      if(referredBy) {
        fetchReferrer(referredBy)
      }
    }
  }

  const fetchReferrer = async (userId) => {
    const response = await userService.getOne(userId);
    if (response.status == 200) {
      setReferrer(response.data.data)
    }
  }

  const generateKYCLink = async (userId) => {
    const response = await userService.generateKYCLink(userId);
    if (response.status == 200) {
      setKycLink(response.data.data.link)
    }
  }

  const sendKycLinkEmail = async (userId) => {
    const data = {
      userId : id,
      link : kycLink
    }
    const response = await userService.sendKYCLinkOnMail(data);
    if (response.status == 200) {
      toast.success("Mail sent successfully!");
    }
  }

  const sendKycLinkPhone = async (userId) => {
    const response = await userService.sendKYCLinkOnPhone(id);
    if (response.status == 200) {
      toast.success("SMS sent successfully!");
    }
  }

  
  const copyToClipboard = (text) => {
      navigator.clipboard.writeText(text).then(() => {
      toast.success("Copy to clipboard");
    });
  };

  return (
    <>
      <div className="dashboard-main-area">
        <Container fluid>
          <div className="dashboard-area-heading management-heading">
            <Row className="pb-4 mb-2 justify-content-center">
              <Col md={12}>
                <h2 className="user-info-heading">
                  <i className="fa fa-angle-left" aria-hidden="true" onClick={() => navigate('/users')}></i> User Management
                </h2>
              </Col>
              <Row className="pb-2">
                <Col md={12}>
                  <div className="user-info-area" >
                    { user ?
                      <>
                        <Row className="mb-4">
                          <Col md={4}>
                            <h6>Joining Date </h6>
                            <p>{ moment(user.createdAt).format('DD-MM-YYYY') }</p>
                          </Col>
                          <Col md={4}>
                            <h6>User Type</h6>
                            <p>
                              {Array.isArray(user.role)
                                ? user.role
                                    .map(role => role.charAt(0).toUpperCase() + role.slice(1).toLowerCase())
                                    .join(', ')
                                : user.role.charAt(0).toUpperCase() + user.role.slice(1).toLowerCase()}
                            </p>
                          </Col>
                         
                          <Col md={4}>
                            <h6> Full Name </h6>
                            <p>{ user.fullName }</p>
                          </Col>

                          <Col md={4}>
                            <h6>Email</h6>
                            <p> { user.email || "N/A"} </p>
                          </Col>

                          <Col md={4}>
                            <h6>Phone</h6>
                            <p>{ user.phone } </p>
                          </Col>
                          <Col md={4}>
                            <h6>Active</h6>
                            <p> { user.enabled ? 'Yes' : 'No' }</p>
                          </Col>
                          <Col md={4}>
                            <h6>Bank Account Added</h6>
                            <p> { user.bankAccountId ? 'Yes' : 'No' }</p>
                          </Col>
                          {user?.role?.includes("VALIDATOR") && (
                          <>
                            <Col md={4}>
                              <h6>KYC Status</h6>
                              <p>
                                {kycStatusMap[user.kycStatus] || 'NA'}

                                {["KYC_LINK_PENDING", "KYC_LINK_GENERATED", "KYC_REQUEST_ACCEPTED"].includes(user.kycStatus) && (
                                  <>
                                    <button className="btn ms-2 btn-primary" onClick={() => generateKYCLink(id)}>
                                      Generate Link
                                    </button>

                                    {kycLink && (
                                      <div className="mt-2 d-flex align-items-center flex-wrap">
                                        <span className="me-2 text-break">{kycLink}</span>
                                        <button
                                          type="button"
                                          className="btn btn-outline-secondary btn-sm"
                                          onClick={() => copyToClipboard(kycLink)}
                                        >
                                          Copy
                                        </button>
                                      </div>
                                    )}
                                  </>
                                )}
                              </p>
                            </Col>

                            {kycLink != null && (
                              <>
                                {user.email && (
                                  <Col md={4}>
                                    <h6>Send KYC Link On Mail</h6>
                                    <p>
                                      <button className="btn ms-2 btn-primary" onClick={() => sendKycLinkEmail(id)}>
                                        Send Mail
                                      </button>
                                    </p>
                                  </Col>
                                )}

                                <Col md={4}>
                                  <h6>Send KYC Link On Phone</h6>
                                  <p>
                                    <button className="btn ms-2 btn-primary" onClick={() => sendKycLinkPhone(id)}>
                                      Send SMS
                                    </button>
                                  </p>
                                </Col>
                              </>
                            )}
                          </>
                        )}

                        </Row>

                      </>
                      :
                      <div className="no-dat-found-box">
                        <img src={ require("../../assets/images/no-data.svg").default} alt="da" />
                        <h3 className="text-center text-light">
                          No data found
                        </h3>
                      </div>}
                  </div>
                </Col>
              </Row>
              { referrer && (
                <Row className="pb-4 border border-2 border-primary rounded">
                <Col md={12}>
                  <div className="user-info-area" >                     
                        <Row className="mb-4">
                          <h2>Referred By</h2>
                          <Col md={4}>
                            <h6>Creation Date </h6>
                            <p>{ moment(referrer.createdAt).format('DD-MM-YYYY') }</p>
                          </Col>
                        
                          <Col md={4}>
                            <h6> Full Name </h6>
                            <p>{ referrer.fullName }</p>
                          </Col>

                          <Col md={4}>
                            <h6>Email</h6>
                            <p> { referrer.email } </p>
                          </Col>

                          <Col md={4}>
                            <h6>Phone</h6>
                            <p>{ referrer.phone } </p>
                          </Col>
                          <Col md={4}>
                            <h6>Active</h6>
                            <p> { referrer.enabled ? 'Yes' : 'No' }</p>
                          </Col>
                          <Col md={4}>
                            <h6>kyc Status</h6>
                            <p>{kycStatusMap[referrer.kycStatus] || 'NA'}</p>
                          </Col >
                        </Row>                                            
                  </div>
                </Col>
              </Row>

              )}

                
              
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
}